module.exports = __webpack_public_path__ + "images/mobile/report-settings-fcba73705604fda1563e33ab3fb1292e.png";